import React, { useEffect } from "react";
import InputField from "../../FormFields/InputField";

const MessageA14s = (props) => {
  useEffect(() => {
    // Only set validation if this is a fresh API response, not from history
    if (!props.isFromHistory) {
      if (props?.item?.code) {
        props.setCodevalue(props.item.code);
      }
      if (props?.item?.data) {
        props.setValidationType(props.item.data);
        sessionStorage.setItem('showNumberHint', 'true');
      }
      props.setEnableA14sValidation(true);
    }
  }, []);
  
  return null;
};

export default MessageA14s;
